import styled from '@emotion/styled';
import { theme } from '@travelnest/hui';
import React from 'react';
import StyledText from '../typography/StyledText';

const Container = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Text = styled(StyledText)`
	color: ${theme.colors.typography.heading};
	position: absolute;
	text-align: center;
  z-index: 1;
	`;

const getIcon = (score: number) => {
	if (score >= 80) return '/92b3b47/assets/icons/property-score/Score=81-100.svg';
	if (score >= 60) return '/92b3b47/assets/icons/property-score/Score=61-80.svg';
	if (score >= 40) return '/92b3b47/assets/icons/property-score/Score=41-60.svg';
	if (score >= 20) return '/92b3b47/assets/icons/property-score/Score=21-40.svg';
	return '/92b3b47/assets/icons/property-score/Score=0-20.svg';
};

interface IPropertyScore {
	score: number;
}

export const PropertyScoreWheel: React.FC<IPropertyScore> = ({ score }) => {
	return (
		<Container>
			<img src={getIcon(score)} width="100%" height="100%" alt={`Property score ${score}/100`} />
			<Text type="IB130" lineHeight="sm">{score}</Text>
		</Container>
	);
};
